<template>
  <div class="valentine-day">
    <div class="valentine-content">
      <img class="avatar" src="./images/avatar.gif" alt="" />
      <ul class="user-box">
        <li class="user-item" v-for="item of list" :key="item.uuid">
          <img class="header-avatar" :src="item.avatarUrl" alt="" />
          <div class="user-name">{{ item.nickname }}</div>
          <button @click="toPlayerInfo(item)">守護</button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WhiteValentineDay',
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    return {
      list: [],
      htmlOriginalFontSize: null
    };
  },
  methods: {
    //跳轉個人詳情頁
    toPlayerInfo(user) {
      const { uuid } = user;
      if (uuid) {
        this.$router.push({
          path: `/player-detail/${uuid}`
        });
      }
    },
    async getPlayerList() {
      try {
        const { data } = await this.$http.get('/master/recently');
        this.list = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '0.625vw'; //设计稿宽1920 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    }
  },
  created() {
    this.initHtmlFontSize();
    if (new Date().getTime() > new Date('2023/03/17').getTime()) {
      this.$dialog
        .confirm({
          message:
            '當前活動已結束，更多福利敬請留意nicee平台，感謝您的支持呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'dialog-center'
        })
        .then(() => {
          // this.$router.push({ path: '/home' });
        });
    }
    this.getPlayerList();
  },
  destroyed() {
    this.resetHtmlFontSize();
  }
};
</script>
<style lang="scss" scoped>
.valentine-day {
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
  .valentine-content {
    width: 100%;
    height: 266.8rem;
    background: url('./images/bg.png') no-repeat center top;
    background-size: 100% auto;
    background-color: #ffcbea;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .avatar {
      position: absolute;
      top: 88.6rem;
      width: 12.34rem;
      height: auto;
      transform: translateX(-4.4rem);
    }
    .user-box {
      display: flex;
      justify-content: space-around;
      // margin-top: 1716px;
      position: absolute;
      top: 184.65rem;
      left: 33.75rem;
      width: 85.167rem;
      height: 27.417rem;
      .user-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 1px;
        flex: auto;
        padding: 0 1rem;
      }
      .header-avatar {
        width: 7.5rem;
        height: 7.5rem;
        object-fit: cover;
        border-radius: 50%;
      }
      .user-name {
        width: 100%;
        padding: 0 1rem;
        margin: 1rem 0;
        height: 6rem;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 2rem;
        text-align: center;
        font-weight: bold;
      }
      button {
        width: 10.5rem;
        height: 4.25rem;
        border-radius: 2.5rem;
        border: 0.25rem solid rgba(0, 0, 0, 1);
        box-sizing: border-box;
        background: rgba(255, 227, 82, 1);
        font-weight: bold;
        font-size: 1.4rem;
      }
    }
  }
}
</style>
<style lang="scss">
.dialog-center {
  .van-dialog__message,
  .van-dialog__header {
    text-align: center;
  }
}
</style>
